import clsx from 'clsx';
import React from 'react';
import styles from './Body.module.scss';

type ModalContentBodyProps = {
  /** The children to render inside the component. */
  children: React.ReactNode;
  /** Optional property for overriding styles. */
  className?: string;
  /** Optional property for overriding styles. */
  style?: React.CSSProperties;
  /** Sets the horizontal alignment of the text. */
  textAlign?: 'start' | 'end' | 'justify' | 'center';
};

/**
 * The dialog's main content.
 */
export const ModalDialogBody = ({
  children,
  className,
  style,
  textAlign = 'start',
}: ModalContentBodyProps) => {
  return (
    <div
      className={clsx(styles.modalDialogBody, className)}
      data-text-align={textAlign}
      data-zds
      style={style}
    >
      <div className={styles.modalDialogBodyInner} data-zds>
        {children}
      </div>
    </div>
  );
};
